import { Environment } from '@rma/public/generic/util/environment';
import * as environments from './environment.base';

export const environment: Environment = environments.aus_environment;
// export const environment: Environment = environments.nz_environment;
// export const environment: Environment = environments.local_environment;
// export const environment: Environment = environments.usa_environment;
